// extracted by mini-css-extract-plugin
export default {"grade":"ComoFunciona_grade__CIWBN","passos":"ComoFunciona_passos__ChwfD","preparo":"ComoFunciona_preparo__UJUCV"};